import type {StoredBlendType} from "#material/nodes/color/mix-rgb/validation"
import {blendTypeAsBlenderSpellsIt} from "#material/nodes/color/mix-rgb/validation"
import type {MixSockets} from "#material/nodes/converter/mix/definition"
import type {MaterialNodeParameters, MaterialNodeSettings} from "#material/sockets/parameters"
import type {Version} from "@cm/graph-v3"

type Current = MaterialNodeParameters<MixSockets>
type Previous = Omit<Current, "settings"> & {settings: Omit<MaterialNodeSettings<MixSockets>, "blendType"> & {blendType?: StoredBlendType}}

/** The same rename the MixRgb node needed, against this node's own settings. */
export const renameBlendTypesToBlender: Version<Previous, Current> = {
    toNextVersion: ({settings = {}, ...parameters}) => ({...parameters, settings: {...settings, blendType: blendTypeAsBlenderSpellsIt(settings.blendType)}}),
}
